export default "__VITE_PUBLIC_ASSET__dc85d757__"